import React from "react";
import { Col, Row, Select } from "antd";
import { Controller } from "react-hook-form";
import CustomTextfield from "../../../../../../common/input/custom-textfield/custom-textfield";
import CustomSelect from "../../../../../../common/input/custom-select/custom-select";
import { institutionType } from "../../../../../../constants/common";

const RegulatoryAcademicInfo = ({ control }) => {
  return (
    <Row gutter={[32, 20]}>
      <Col span={12}>
        <Controller
          name="education_authority"
          control={control}
          rules={{ required: true }}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomTextfield
              id="education_authority"
              label="Education Authority / Ministry"
              showRequired
              labelColor="#171717"
              placeholder="Enter name"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="levels_offered"
          control={control}
          rules={{ required: true }}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomTextfield
              id="levels_offered"
              label="Levels Offered"
              showRequired
              labelColor="#171717"
              placeholder="Enter levels"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="total_students"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomTextfield
              id="total_students"
              label="Number of Students"
              showOptional
              labelColor="#171717"
              placeholder="Enter number"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="total_teachers"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomTextfield
              id="total_teachers"
              label="Number of Teachers"
              showOptional
              labelColor="#171717"
              placeholder="Enter number"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="total_classes"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomTextfield
              id="total_classes"
              label="Number of Classes"
              showOptional
              labelColor="#171717"
              placeholder="Enter number"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="total_support_staffs"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomTextfield
              id="total_support_staffs"
              label="Number of Ancillary/Support Staff"
              showOptional
              labelColor="#171717"
              placeholder="Enter number"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="boarding_or_day"
          control={control}
          rules={{ required: true }}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomSelect
              id="boarding_or_day"
              label="Boarding or Day"
              showRequired
              labelColor="#171717"
              placeholder="--Select--"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            >
              {institutionType.map((item, index) => (
                <Select.Option key={index} value={item?.value}>
                  {item?.label}
                </Select.Option>
              ))}
            </CustomSelect>
          )}
        />
      </Col>
    </Row>
  )
};

export default RegulatoryAcademicInfo;